import { useEffect, useState } from "react";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

interface IGetCompaniesAll {
  code: number;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  idTenant: string;
}

export const HttpGetCompaniesAll = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const [data, setData] = useState<IGetCompaniesAll[]>([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleGet = () => {
      setLoading(true);

      api
        .get(`/companies/all`)
        .then(({ data }) => {
          setData(data.data);
        })
        .catch((error) =>
          handleGetAlert({ message: error.response.data.message })
        )
        .finally(() => setLoading(false));
    };

    handleGet();
  }, []);

  return { loading, data };
};
